import type { LogEntry, RunState } from "../types/index.js";

let logCounter = 0;

export function appendLog(
  run: RunState,
  entry: Omit<LogEntry, "id" | "createdAt">,
): RunState {
  logCounter += 1;
  const log = [...run.log, { ...entry, id: `log-${logCounter}`, createdAt: logCounter }];
  if (log.length > 100) log.shift();
  return { ...run, log };
}

export function resetLogCounter(): void {
  logCounter = 0;
}

/** Records a deck cycle. `rngState` only advances during a reshuffle for draw effects. */
export function appendReshuffleLogIfNeeded(
  before: RunState,
  after: RunState,
  phase: number,
  reshuffled = before.rngState !== after.rngState,
): RunState {
  if (!reshuffled) return after;
  return appendLog(after, {
    phase,
    kind: "deck",
    message: "捨て札をシャッフルして山札にしました。",
  });
}
